import React,  { useState, useEffect }  from 'react';
import { useParams  } from 'react-router-dom';
import Cookies from 'js-cookie'

import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {FormControl , TextField, Grid , Box,  MenuItem , Typography,InputLabel,Button , CardMedia} from '@mui/material/';
import Autorize from '../../components/ui/autorize';
import { setSession,setEmptySession } from '../../utils/userRule';

import YouTube from 'react-youtube';


import MyImgLarge from '../../ressource/Logo-Opti-jeunesse.png';
import croissance from '../../ressource/croissance.png';
import trousse from '../../ressource/trousse.png';
import certificat from '../../ressource/certificat.png';
//import Button from 'react-bootstrap/Button';
import PoPupConsentement from '../../components/lib/dialog_consentement'
//function Home() {


export default function Home()
{
  
  const { token } = useParams();

  const [autorize, setAutorize] = useState(false);
  const [myParam,setmyParam] = useState(useParams());
  const [introuvable, setIntrouvable] = useState(false);
  const [introuvableEmail, setIntrouvableEmail] = useState("");
  const [TokenValide, setTokenValide] = useState(false);

  const [openConsentement, setOpenConsentement] = useState(false);

  const navigate = useNavigate();



  
async function test1(MyToken)
{ 
 
      setEmptySession();
        const TT = await axios.get(process.env.REACT_APP_API + '/auth/getValideUser',{
          headers: {
            Authorization: 'Bearer ' + MyToken
        }}) 
        .then((res) => {  
          console.log(res.data);
             if(res.data !== false)
             {
                setSession(MyToken);
                // alert(res.data);
                if(TokenValide === false)
                    setTokenValide(true);
               // alert("validToken");
              
              return true;
              //setIntrouvableEmail(user.user.email);
               //console.log(myParam);

             }
             else
             {
              if(TokenValide === true)
                  setTokenValide(false);
           
              return false;
             }


            
           
            // setErrorAxios(false);  
             
            // setSession(myParam.token);
           // 
            
          })
          .catch((error) => {
            // setErrorAxios(true);
            
            
              // setSessionValide(getSessionExpirer());
                //console.log(sessionValide);
                // Cookies.set('token',  myParam.token , {secure: true, sameSite: 'none'});
                //const user = jwt(myParam.token); // decode your token here     
                // console.log(user);     
                // Cookies.set('useremail',  user.user.email);          
                return false;  
              window.location.href = process.env.REACT_APP_FRONTEND_UI
          });



        if(TT === true)
            window.location.href = process.env.REACT_APP_FRONTEND_UI + "/home"
              //navigate("/home");
         
}





  useEffect(async () => {   

          // console.log(myParam);
          if(myParam.token)//  /param/:token
          {         
            
              await test1(myParam.token);
             // window.location.href = process.env.REACT_APP_FRONTEND_UI;
          //else
        //   window.location.href = process.env.REACT_APP_FRONTEND_UI
          }
          else
          {
               await test1(Cookies.get('token'));
          
           // setEmptySession();
          }


   
    

          
  },[TokenValide]);

    function AutoriseContent()
    {
      
      
        if(introuvable === true)
        {
          return (    <Grid container direction="row" spacing={2}>    
                      <Grid item sx={4} maxWidth="650px">
                        <h1>{introuvableEmail} introuvable</h1>
                        <h4>L'adresse courriel que vous utilisez sur Facebook ou Gmail {introuvableEmail} est introuvable dans notre liste d'officier.</h4>
                        <p>Vous pouvez remplir le formulaire suivant pour demander un changement d'adresse email (compter 2 semaines entre la demande et le mise à jour de votre compte)</p>
                        <p><a href="https://docs.google.com/forms/d/e/1FAIpQLSdrqSxSksFo2aLgXmAOYalFvuPrPxfsFnFoi-QX2F1tkNuarQ/viewform?usp=sf_link">CLIQUEZ ICI POUR REMPLIR LE FORMULAIRE</a></p>
                       
                        <p>Si vous avez des questions, commentaires ou si vous éprouvez des problèmes, communiquez avec nous : <a href="mailto:info@opti-jeunesse.org">info@opti-jeunesse.org</a></p>
                      </Grid>
                  </Grid>);

        }
        else
        {
            return (<Grid container direction="row" spacing={2}>    
                    <Grid item sx={4} maxWidth="650px">
                    <h1>Bienvenue Dirigeants Opti-jeunesse  </h1>
                    <p>Ce site a changé d’emplacement !</p>
                    <h2><a href="https://dirigeants-dot-opti-jeunesse.nn.r.appspot.com/">Dirigeants opti-jeunesse</a></h2> 


                    
                  </Grid>
                  <Grid item sx={4}>

                      <Box
                          component="img"
                          sx={{
                            height: 350,
                            width: 350,                          
                          }}
                          alt="The house from the offer."
                          src={MyImgLarge}
                        />


                  </Grid>
                  </Grid>);


        }
          

    }

   

  return  (
            <div>
               
              <Grid container justifyContent="center" alignItems="center">
                <Grid item sx={4} >

                    {AutoriseContent() }

                </Grid>
                  
              </Grid>

           </div>
     

    );

}
